import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!
  const _component_answer_button = _resolveComponent("answer-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_message_wrap, {
      isShowMessageTail: _ctx.isShowMessageTail,
      message: _ctx.message,
      avatar: _ctx.avatar,
      onInit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('init')))
    }, null, 8, ["isShowMessageTail", "message", "avatar"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_answer_button, {
          key: button.params?.answer_id ?? index,
          button: button,
          onClickButtonWithPayload: _cache[1] || (_cache[1] = (payload) => _ctx.$emit('send-message', payload))
        }, null, 8, ["button"]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
}